module.exports = __webpack_public_path__ + "static/img/hitbox-icon-box.d60b2670.png";